import { jsx as _jsx } from "react/jsx-runtime";
import TabsCarouselProductCardDesktop from "../../../../../common/others/tabs-carousel-product-card/views/desktop/index.js";
import { bannerProductCardMarketingDesktopConverter, tabsProductCardMarketingDesktopConverter } from "../../../../../../helpers/wrappers/marketing/tabs-product-card/desktop/converter.js";
import { getTabsProductsMarketing } from "../../service.js";
import { TABS_CAROUSEL_PRODUCT_CARD_MARKETING_ENDPOINT } from "../../utils.js";
export const TabsCarouselProductCardMarketingDesktop = (props)=>{
    const converter = tabsProductCardMarketingDesktopConverter(props);
    const getTabsProducts = async (index)=>{
        const { items =[] , config ={}  } = converter.props;
        const body = {
            Name: 'banner-product-card-carousel',
            BusinessAreaName: 'Home',
            Arguments: items[index].params?.map(({ name ='' , key , value =''  })=>({
                    Name: name,
                    Key: key,
                    Value: value.toString()
                }))
        };
        const props = await getTabsProductsMarketing(config.endpoint ?? TABS_CAROUSEL_PRODUCT_CARD_MARKETING_ENDPOINT, body);
        return bannerProductCardMarketingDesktopConverter({
            props
        });
    };
    return /*#__PURE__*/ _jsx(TabsCarouselProductCardDesktop, {
        props: {
            ...converter.props,
            getTabsProducts
        }
    });
};
export default TabsCarouselProductCardMarketingDesktop;

//# sourceMappingURL=index.js.map